module.exports = __webpack_public_path__ + "static/img/box4bg.845e737.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/box4bg.png
// module id = fc03
// module chunks = 0